import { useEffect, useState } from 'react';
import { Field } from '../../components/field/field';
import { EcommerceButton } from '../../components/form/button';
import { Card } from '../../components/card/card';
import { Typography } from '../../components/typography/typography';
import { useCustomerAPI } from '../../clients/customer-api/customer-api-client';
import { CouponLineItem } from '../../clients/quipli-service/financials/financials';
import { ecommerceToast } from '../../util/toasts';
import { Location } from '../../clients/quipli-service/location/location';
import { Cart } from '../../clients/customer-api/cart/cart';

export const CheckoutCoupon = ({
  coupon,
  cart,
  location,
  setCoupon,
  isSubmitting,
}: {
  coupon?: CouponLineItem;
  cart: Cart;
  location: Location;
  setCoupon?: (c?: string) => void;
  isSubmitting: boolean;
}) => {
  const { getCouponByCode, updateCartMeta } = useCustomerAPI();

  const [inputValue, setInputValue] = useState<string>('');
  const isTagPricing = coupon?.type === 'TagPricing';

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.stopPropagation();
    e.preventDefault();

    if (coupon) {
      await updateCartMeta({ ...cart.meta, coupon: undefined }, location.id);
      setCoupon?.(undefined);
      ecommerceToast('Coupon removed successfully.');
    } else {
      applyCoupon();
    }
  };

  const applyCoupon = async () => {
    if (!inputValue) return;

    try {
      const res = await getCouponByCode(inputValue);
      if (res) {
        await updateCartMeta({ ...cart.meta, coupon: res.code }, location.id);

        setCoupon?.(res.code);
        ecommerceToast('Coupon applied successfully.');
      } else {
        ecommerceToast('Invalid coupon.', 'error');
      }
    } catch (e: any) {
      ecommerceToast(e.message || 'Something went wrong.', 'error');
    }
  };

  useEffect(() => {
    setInputValue(coupon?.code || '');
  }, [coupon]);

  return (
    <Card className="rounded-lg shadow-sm flex flex-col py-4 px-3 gap-3">
      <Typography type="text-md" weight="semi-bold">
        Coupon
      </Typography>

      <form onSubmit={handleSubmit}>
        <Field
          type="text"
          placeholder="Enter your coupon"
          dataCy="coupon-input"
          value={inputValue}
          onChange={(newvalue) => setInputValue(newvalue)}
          disabled={!!coupon || isSubmitting}
        />

        {!isTagPricing && (
          <EcommerceButton buttonStyle="secondary" type="submit" disabled={isSubmitting}>
            {coupon ? 'Delete' : 'Apply'} Coupon
          </EcommerceButton>
        )}
      </form>
    </Card>
  );
};
